export enum FontFormat {
  'eot' = 'embedded-opentype',
  'woff2' = 'woff2',
  'woff' = 'woff',
  'otf' = 'opentype',
  'ttf' = 'truetype',
  'svg' = 'svg'
}
